export type UUID = `${string}-${string}-${string}-${string}-${string}` & {
  readonly __brand: 'UUID';
};

const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isUUID(value: string): value is UUID {
  return UUID_REGEX.test(value);
}
